import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/styles.scss';export default {
  "reportsPage": "_reportsPage_9akdm_1",
  "filters": "_filters_9akdm_9",
  "main": "_main_9akdm_17",
  "list": "_list_9akdm_24",
  "reportsList": "_reportsList_9akdm_32",
  "buttonBox": "_buttonBox_9akdm_38",
  "button": "_button_9akdm_38",
  "exportButton": "_exportButton_9akdm_57"
};